import React from 'react';
import './TimePicker.css';

import Isvg from 'react-inlinesvg';

import { leftPad } from '../../utils/string';

const propTypes = {
  hours: React.PropTypes.number.isRequired,
  minutes: React.PropTypes.number.isRequired,
  onIncreaseHourClick: React.PropTypes.func.isRequired,
  onDecreaseHourClick: React.PropTypes.func.isRequired,
  onIncreaseMinuteClick: React.PropTypes.func.isRequired,
  onDecreaseMinuteClick: React.PropTypes.func.isRequired,
  onIncreasePeriodClick: React.PropTypes.func.isRequired,
  onDecreasePeriodClick: React.PropTypes.func.isRequired
}

const btnIcon = <Isvg src={`${process.env.PUBLIC_URL}/icons/chevron.svg`} cacheGetRequests={true}/>
const decreaseBtnClass = 'timepicker__btn timepicker__btn--decrease u-rotate-180';
const increaseBtnClass = 'timepicker__btn timepicker__btn--increase';

const TimePicker = props => (
  <div className='timepicker'>
    <div className='timepicker__col timepicker__col--hour'>
      <button className={increaseBtnClass} onClick={props.onIncreaseHourClick}>
        {btnIcon}
      </button>
      <span className='timepicker__number'>
        {props.hours === 0 || props.hours === 12 ? 12 : props.hours % 12}
      </span>
      <button className={decreaseBtnClass} onClick={props.onDecreaseHourClick}>
        {btnIcon}
      </button>
    </div>
    <div className='timepicker__col timepicker__col--colon'>
      <span className='timepicker__number'>:</span>
    </div>
    <div className='timepicker__col timepicker__col--minutes'>
      <button className={increaseBtnClass} onClick={props.onIncreaseMinuteClick}>
        {btnIcon}
      </button>
      <span className='timepicker__number'>
        {leftPad(props.minutes)}
      </span>
      <button className={decreaseBtnClass} onClick={props.onDecreaseMinuteClick}>
        {btnIcon}
      </button>
    </div>
    <div className='timepicker__col timepicker__col--period'>
      <button className={increaseBtnClass} onClick={props.onIncreasePeriodClick}>
        {btnIcon}
      </button>
      <span className='timepicker__period'>
        {props.hours >= 12 ? 'pm' : 'am'}
      </span>
      <button className={decreaseBtnClass} onClick={props.onDecreasePeriodClick}>
        {btnIcon}
      </button>
    </div>
  </div>
)

TimePicker.propTypes = propTypes;

export default TimePicker;



// WEBPACK FOOTER //
// ./src/components/TimePicker/TimePicker.js